/*eslint-disable*/ export const messages = {
    Apply: "Aplicar",
    "Changed the date": "Cambió la fecha",
    Clear: "Borrar",
    "Date picker open, choose a date": "Selector de fecha abierto; elija una fecha",
    "Date range picker open, select a date range":
        "Selector de intervalo de fechas abierto; seleccione un intervalo de fechas",
    "End Date": "Fecha de finalización",
    "Please enter a valid date ({format})": ["Introduzca una fecha válida (", ["format"], ")"],
    "Please select a date after {minDate}": ["Seleccione una fecha posterior al ", ["minDate"]],
    "Please select a date before {maxDate}": ["Seleccione una fecha anterior al ", ["maxDate"]],
    "Show next month": "Mostrar el mes siguiente",
    "Show previous month": "Mostrar el mes anterior",
    "Start Date": "Fecha de inicio",
    "The selected date is disabled": "La fecha seleccionada está deshabilitada",
    "The selected date is unavailable. Please select another.":
        "La fecha seleccionada no está disponible. Seleccione otra.",
    Today: "Hoy",
    "Today, {dateStr}": ["Hoy, ", ["dateStr"]],
    "date picker": "selector de fecha",
    "start date selected": "fecha de inicio seleccionada",
    to: "al",
    "{dateStr}, select end date": [["dateStr"], ", seleccionar fecha de finalización"],
    "{dateStr}, select start date": [["dateStr"], ", seleccionar fecha de inicio"],
    "{startDate} to {endDate}, choose apply to confirm, or cancel": [
        ["startDate"],
        " al ",
        ["endDate"],
        "; elija “Aplicar” para confirmar, o “Cancelar”",
    ],
};
